















































































































































































































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";

import http from "../../service/data-service";
import DatePicker from "../../components/date-picker.vue";
import NumberSelector from "../../components/number-selector.vue";
import { Form } from "../form";
import { requiredRule } from "../form-rules";
import Util from "../../service/util-service";

@Component({
  components: {
    "date-picker": () => Promise.resolve(DatePicker),
    "number-selector": () => Promise.resolve(NumberSelector),
  },
})
export default class ConcursoDuplaSena extends Vue {
  @Prop({ required: true })
  public concurso!: any;
  @Prop({ required: true })
  public concursoDuplaSena!: any;
  @Prop({ required: true })
  public dialogControler!: any;

  concursoDuplaSenaKey = 0;
  numberSelectorKey = 0;

  alerts = false;
  alertKey = 0;
  alertError = "";

  init() {}

  created() {
    this.numberSelectorKey += 1;
  }

  formDuplaSena: Form = {
    valid: false,
    fields: {
      localizacao: "",
    },
    rules: {
      localizacao: [requiredRule()],
      extProxConc: [requiredRule()],
      acProxConc: [requiredRule()],
      acVirada: [requiredRule()],
      premioSena: [requiredRule()],
      ganhadoresSena: [requiredRule()],
      premioQuina: [requiredRule()],
      ganhadoresQuina: [requiredRule()],
      premioQuadra: [requiredRule()],
      ganhadoresQuadra: [requiredRule()],
    },
  };

  validate(): boolean {
    if (this.$refs.form as Vue) {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  finalConcurso() {
    if (this.concurso) {
      if (this.concurso.numero) {
        let arr = Array.from(this.concurso.numero.toString());
        var ultimoDigito: number = Number(arr[arr.length - 1]);
        if (ultimoDigito >= 5) {
          return "Estimativa próximo concurso final 0";
        } else {
          return "Estimativa próximo concurso final 5";
        }
      }
    }
  }
  onClose() {
    this.$emit("onCloseConcurso");
    this.$emit("update:dialogControler", false);
  }
  onSave() {
    if (
      (this.$refs.formDuplaSena as Vue & { validate: () => boolean }).validate()
    ) {
      if (
        Util.isArrayPopulated(this.concursoDuplaSena.numeros1) &&
        Util.isArrayPopulated(this.concursoDuplaSena.numeros2)
      ) {
      console.log("nao asdasdfasdfasdf");
        this.$emit("onSaveConcurso");
      } else {
        this.alertKey += 1;
        this.alertError = "Selecione os números do concurso";
        this.alerts = true;
      }
    } else {
      console.log("nao validou");
    }
  }
}
